define('SuiteDynamics.B2BPromoMessaging.Entrypoint',
	[
		'SuiteDynamics.B2BPromoMessaging.HomeModifications',
		'SuiteDynamics.B2BPromoMessaging.HeaderModifications',
		'SuiteDynamics.B2BPromoMessaging.PLPModifications'
	],
	function (
		HomeModifications,
		HeaderModifications,
		PLPModifications
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container) {
			HomeModifications.mountToApp(container);
			HeaderModifications.mountToApp(container);
			PLPModifications.mountToApp(container);
		}
	};
});
